







































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { slug } from '@/utils'
import IUser from '@/models/IUser'
import LangChanger from '@/components/LangChanger.vue'
import userService from '@/services/UserService'
import queueNotifService from '@/services/QueueNotifService'

const enableAnonymous: boolean = false

@Component({
  components: {
    LangChanger,
    'account-list': () => import('@/components/AccountList.vue'),
    'confirm-button': () => import('@/components/ConfirmButton.vue'),
    'pricing-table': () => import('@/components/PricingTable.vue'),
    'payment-checkout': () => import('@/components/Payment.vue')
  }
})
export default class User extends Vue {
  @Prop({ type: String, required: false, default: '' })
  public premail!: string
  @Getter
  public user!: IUser | null
  @Action
  public login!: any
  @Action
  public signup!: any
  @Action
  public logout!: any
  @Action
  public remove!: any
  public activeTab: string = 'login'
  public email: string = ''
  public password: string = ''
  public confirmPassword: string = ''
  public firstname: string = ''
  public lastname: string = ''
  public isLoading: boolean = false
  public show: boolean = false
  public replicate: boolean = false
  public confirmed: boolean = false
  private localeUserId: string = ''

  public mounted(): void {
    if (this.premail) {
      this.email = this.premail
    }
  }

  public async signin(): Promise<void> {
    this.isLoading = true
    await this.login({
      userId: this.userId,
      password: this.password
    })
    this.isLoading = false
  }

  public toReplicate(replicate: boolean): void {
    this.replicate = replicate
    this.show = false
    this.register(true)
  }

  public async register(confirmed: boolean): Promise<void> {
    if (!this.validateRegistration()) {
      return
    }
    try {
      if (
        enableAnonymous &&
        (await userService.hasAnonymousData()) &&
        !confirmed
      ) {
        if (!this.show) {
          this.show = true
        }
        return
      }
    } catch (error) {
      queueNotifService.error(
        `Une erreur est survenue à la vérification d'un compte anonyme déjà créé.`
      )
      // tslint:disable-next-line
      console.warn({ error })
    }
    this.isLoading = true
    try {
      const user: IUser = {
        userId: this.userId,
        email: this.email,
        premium: false,
        slugEmail: this.slugEmail,
        firstname: this.firstname,
        lastname: this.lastname
      }
      await this.signup({
        user,
        password: this.password,
        replicate: this.replicate
      })
    } catch (error) {
      queueNotifService.error(
        `Une erreur est survenue à la création du compte utilisateur.`
      )
      // tslint:disable-next-line
      console.warn({ error })
    }
    this.isLoading = false
  }

  public validateRegistration(): boolean {
    if (!this.userId) {
      queueNotifService.error('Un pseudo est obligatoire.')
      return false
    }
    if (this.password !== this.confirmPassword) {
      queueNotifService.error('Les mots de passe doivent être identique.')
      return false
    }
    return true
  }

  public async purge(): Promise<void> {
    await userService.purge()
    queueNotifService.success(this.$t('user.purgeDone').toString())
  }

  public get slugEmail(): string {
    return slug(this.email)
  }

  public set userId(newUserId: string) {
    this.localeUserId = (newUserId || '').toLowerCase()
  }

  public get userId() {
    return this.localeUserId
  }
}
